import type { User as FirebaseUser } from 'firebase/auth';

export function shouldRequireEmailVerification(
  user: FirebaseUser | null,
  signInProvider?: string | null,
): boolean {
  if (!user) return false;
  if (user.emailVerified) return false;

  const normalizedProvider = typeof signInProvider === 'string'
    ? signInProvider.trim().toLowerCase()
    : '';
  if (normalizedProvider) {
    return normalizedProvider === 'password';
  }

  const providerIds = (user.providerData || [])
    .map((provider) => provider?.providerId)
    .filter((providerId): providerId is string => Boolean(providerId));
  if (providerIds.length === 0) return true;
  if (providerIds.length > 1 && providerIds.includes('password')) {
    // Linked-account fallback: without token claims, avoid forcing a frontend gate
    // that backend enforcement may not require for the active provider.
    return false;
  }
  return providerIds.includes('password');
}
